// Constants extracted from mockData.ts — these are config/reference data, not mock data

export type UserRole = 'participant' | 'mentor' | 'admin' | 'super_admin' | null;

export type DeliverableStatus = 'not_started' | 'in_progress' | 'submitted' | 'validated' | 'needs_revision' | 'rejected';

export type SolutionType = 1 | 2 | 3 | 4 | 5;

// Convención canónica de solution_type (ver SOLUTION_TYPE_MAP en useProjects.ts):
// 1 Contenido · 2 Vibecoding · 3 Asistente · 4 Automatización · 5 Análisis de Datos
export const SOLUTION_TYPES = {
  1: { 
    name: 'Creación de Contenido con IA', 
    icon: '✍️',
    description: 'Genera contenido de valor usando herramientas de IA',
    color: 'level-1'
  },
  2: { 
    name: 'Vibe Coding', 
    icon: '💻',
    description: 'Crea soluciones y aplicaciones con IA',
    color: 'level-2'
  },
  3: { 
    name: 'Asistentes o Agentes Inteligentes', 
    icon: '🤖',
    description: 'Crea asistentes que automaticen interacciones',
    color: 'level-3'
  },
  4: { 
    name: 'Automatizaciones', 
    icon: '⚙️',
    description: 'Automatiza procesos con herramientas no-code',
    color: 'level-4'
  },
  5: { 
    name: 'Análisis de Datos con IA', 
    icon: '📊',
    description: 'Analiza y visualiza datos para tomar mejores decisiones',
    color: 'level-5'
  },
} as const;

export const TOOLS = [
  { id: 'chatgpt', name: 'ChatGPT', category: 'IA', icon: '🤖' },
  { id: 'claude', name: 'Claude', category: 'IA', icon: '🧠' },
  { id: 'midjourney', name: 'Midjourney', category: 'IA', icon: '🎨' },
  { id: 'powerbi', name: 'Power BI', category: 'Análisis', icon: '📊' },
  { id: 'looker', name: 'Looker', category: 'Análisis', icon: '📈' },
  { id: 'notion', name: 'Notion', category: 'Productividad', icon: '📝' },
  { id: 'make', name: 'Make', category: 'Automatización', icon: '⚙️' },
  { id: 'n8n', name: 'n8n', category: 'Automatización', icon: '🔄' },
  { id: 'zapier', name: 'Zapier', category: 'Automatización', icon: '⚡' },
  { id: 'softr', name: 'Softr', category: 'Frontend', icon: '🖥️' },
  { id: 'lovable', name: 'Lovable', category: 'Vibe Coding', icon: '💜' },
];

export const BADGES: Record<string, { name: string; icon: string; description: string }> = {
  early_bird: { name: 'Early Bird', icon: '🐦', description: 'Completó su primer entregable en la primera semana' },
  first_delivery: { name: 'Primera Entrega', icon: '🎯', description: 'Envió su primer entregable' },
  content_master: { name: 'Maestro del Contenido', icon: '✍️', description: 'Completó el módulo de Creación de Contenido' },
  data_analyst: { name: 'Analista de Datos', icon: '📊', description: 'Completó el módulo de Análisis de Datos' },
  agent_builder: { name: 'Constructor de Agentes', icon: '🤖', description: 'Completó el módulo de Asistentes' },
  automation_expert: { name: 'Experto en Automatización', icon: '⚡', description: 'Completó el módulo de Automatización' },
  streak_3: { name: 'En Racha', icon: '🔥', description: '3 días consecutivos entregando' },
  streak_7: { name: 'Imparable', icon: '💪', description: '7 días consecutivos entregando' },
  demoday_ready: { name: 'Listo para Demoday', icon: '🎤', description: 'Completó todos los requisitos' },
};

export type CalendarEventType = 'workshop' | 'mentoring' | 'content' | 'project_delivery' | 'deadline' | 'demoday';
export type CalendarEventStatus = 'upcoming' | 'live' | 'completed';

export interface CalendarEvent {
  id: string;
  title: string;
  description: string;
  type: CalendarEventType;
  date: string;
  startTime: string;
  endTime: string;
  status: CalendarEventStatus;
  week: number;
  company?: string;
  meetLink?: string;
  recordingUrl?: string;
  meetRecordingUrl?: string;
  materialUrl?: string;
  mentor?: string;
  expert?: Expert;
  deliverableId?: string;
  deliverableUploaded?: boolean;
  deliverableInstructions?: string;
  deliverableTools?: string[];
  duration?: string;
  deliverableStatus?: string;
  deliverableFeedback?: string | null;
  deliverableFileUrl?: string;
  deliverableSubmittedAt?: string;
  problemaConcreto?: string;
  resultadoEsperado?: string;
  tiempoEstimado?: string;
  tipAdicional?: string;
  deliverableResourceUrl?: string | null;
}

export interface Expert {
  id: string;
  name: string;
  photo: string;
  profile: string;
  linkedinUrl: string;
}
